//main actions call these workers and actions those ended with STATE will change state

import { takeLatest, call, put } from "redux-saga/effects";
import {
  ADD_NEW_DRIVER_STATE,
  REMOVE_DRIVER_STATE,
  ADD_NEW_DRIVER,
  REMOVE_DRIVER,
  ADD_NEW_DRIVERS,
  ADD_NEW_DRIVERS_STATE,
  UPDATE_DRIVER_STATE,
  UPDATE_DRIVER,
  IMPORT_NEW_DRIVERS,
} from "../../constants/actions-types";
import {
  updateDriver,
  findAllDriver,
  saveDriver,
  deleteDriver,
} from "./methods/driverMethods";

function* workerFindAllDrivers() {
  try {
    console.log("add all drivers");
    const result = yield call(findAllDriver);
    yield put({ type: ADD_NEW_DRIVERS_STATE, drivers: result });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerSaveDriver(action) {
  try {
    const result = yield call(saveDriver, action.driver);
    yield put({ type: ADD_NEW_DRIVER_STATE, driver: result });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerSaveAllDrivers(action) {
  try {
    let drivers = JSON.parse(action.drivers);
    const result = yield call(saveDriver, drivers);
    yield put({ type: ADD_NEW_DRIVERS });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerUpdateDriver(action) {
  try {
    const result = yield call(updateDriver, action.driver, action.update);
    yield put({ type: UPDATE_DRIVER_STATE, driver: action.update });
  } catch (ex) {
    console.log(ex);
  }
}

function* workerDeleteDriver(action) {
  try {
    yield call(deleteDriver, action.driver);
    yield put({ type: REMOVE_DRIVER_STATE, driver: action.driver });
  } catch (ex) {
    console.log(ex);
  }
}

function* watcherSaveAllDrivers() {
  yield takeLatest(IMPORT_NEW_DRIVERS, workerSaveAllDrivers);
}

function* watcherUpdateDriver() {
  yield takeLatest(UPDATE_DRIVER, workerUpdateDriver);
}

function* watcherFindAllDrivers() {
  yield takeLatest(ADD_NEW_DRIVERS, workerFindAllDrivers);
}

function* watcherSaveDriver() {
  yield takeLatest(ADD_NEW_DRIVER, workerSaveDriver);
}

function* watcherRemoveDriver() {
  yield takeLatest(REMOVE_DRIVER, workerDeleteDriver);
}

export {
  watcherSaveDriver,
  watcherRemoveDriver,
  watcherFindAllDrivers,
  watcherUpdateDriver,
  watcherSaveAllDrivers,
};
